<template>
  <v-dialog v-model="dialog" max-width="800px">
    <BaseBodyDialog title="Tạo mẫu đánh giá mới" :loading="loading" @close="closeDialog" @save="createEvaluation">
      <v-form class="mt-6" ref="form" v-model="valid">
        <AutocompleteClass
          v-model="selectedClass"
          label="Chọn lớp"
          required
          :rules="[(v) => !!v || 'Lớp là bắt buộc']"
          outlined
          dense
          @change="fetchLessonsByClass"
        />

        <v-text-field
          v-model="evaluationName"
          label="Tên đánh giá"
          required
          :rules="[(v) => !!v || 'Tên đánh giá là bắt buộc']"
          outlined
          dense
        ></v-text-field>

        <v-select
          v-model="evaluationType"
          :items="evaluationTypes"
          label="Phân loại đánh giá"
          required
          :rules="[(v) => !!v || 'Phân loại đánh giá là bắt buộc']"
          outlined
          dense
        ></v-select>

        <v-autocomplete
          v-if="evaluationType === 'custom'"
          v-model="specificSession"
          :items="formattedLessons"
          item-text="formattedTitle"
          item-value="id"
          label="Tại buổi"
          required
          :rules="[(v) => !!v || 'Buổi cụ thể là bắt buộc khi chọn đánh giá theo thời điểm']"
          outlined
          dense
          :loading="loadingLessons"
          :disabled="!selectedClass"
        ></v-autocomplete>

        <v-divider class="my-4"></v-divider>

        <v-subheader class="pl-0">Tiêu chí đánh giá</v-subheader>
        <v-alert type="info" dense outlined color="primary">
          Lưu ý: Tiêu chí đánh giá sẽ được sắp xếp theo thứ tự khi gửi báo cáo.
        </v-alert>

        <v-select
          v-model="selectedCriteria"
          :items="evaluateCriterias"
          item-text="title"
          item-value="id"
          label="Chọn tiêu chí đánh giá"
          multiple
          chips
          outlined
          dense
        >
          <template v-slot:selection="{ item, index }">
            <v-chip class="my-2" v-if="index < 5" small>
              <span>{{ item.title }}</span>
              <v-icon small right @click.stop="removeCriteria(item.id)">mdi-close</v-icon>
            </v-chip>
            <span v-else-if="index === 5" class="grey--text text-caption">
              (+{{ selectedCriteria.length - 5 }} others)
            </span>
          </template>
        </v-select>
      </v-form>
    </BaseBodyDialog>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass.vue'
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog.vue'

export default {
  components: {
    AutocompleteClass,
    BaseBodyDialog
  },
  data() {
    return {
      dialog: false,
      valid: false,
      selectedClass: null,
      evaluationName: '',
      evaluationType: '',
      specificSession: '',
      evaluationTypes: [
        { text: 'Đánh giá theo buổi', value: 'session' },
        { text: 'Đánh giá theo thời điểm', value: 'custom' },
      ],
      selectedCriteria: [],
      lessons: [],
      loadingLessons: false,
    }
  },
  computed: {
    ...mapState('evaluateCriteria', ['evaluateCriterias']),
    ...mapState('evaluate', ['loading', 'error']),
    formattedLessons() {
      return this.lessons.map(lesson => ({
        ...lesson,
        formattedTitle: `${lesson.classTitle} - ${this.formatDate(lesson.date)} ${this.formatTime(lesson.startTime)}`
      }))
    }
  },
  methods: {
    ...mapActions('evaluateCriteria', ['fetchEvaluateCriterias']),
    ...mapActions('lesson', ['fetchLessons']),
    ...mapActions('evaluate', ['generateEvaluate']),
    openDialog() {
      this.dialog = true
      this.fetchEvaluateCriterias()
    },
    closeDialog() {
      this.dialog = false
      this.$refs.form.reset()
      this.selectedClass = null
      this.selectedCriteria = []
      this.lessons = []
    },
    async fetchLessonsByClass() {
      if (this.selectedClass) {
        this.loadingLessons = true
        try {
          this.lessons = await this.fetchLessons({ class: this.selectedClass.id })
        } catch (error) {
          console.error('Error fetching lessons:', error)
        } finally {
          this.loadingLessons = false
        }
      }
    },
    async createEvaluation() {
      if (this.$refs.form.validate()) {
        const evaluationData = {
          classId: this.selectedClass.id,
          evaluationName: this.evaluationName,
          evaluationType: this.evaluationType,
          specificLesson: this.evaluationType === 'custom' ? this.specificSession : null,
          criteria: this.selectedCriteria,
        }
        try {
          await this.generateEvaluate(evaluationData)
          this.$emit('evaluation-created')
          this.closeDialog()
        } catch (error) {
          console.error('Error creating evaluation:', error)
        }
      }
    },
    removeCriteria(id) {
      this.selectedCriteria = this.selectedCriteria.filter((criteriaId) => criteriaId !== id)
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('vi-VN', { day: '2-digit', month: '2-digit', year: 'numeric' })
    },
    formatTime(time) {
      return time.slice(0, 5) // Assuming time is in HH:MM:SS format, we only show HH:MM
    }
  },
}
</script>
